<template>
  <div class="izt-chat-header">
    <!-- <div class="chat-header_image">
      <div class="image-wrap">
        <van-image width="252" height="45" :src="titleUrl" />
        <img class="title-bot-img" width="46" height="34" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/ai/v2/title_bot.png">
      </div>
    </div> -->
    <div class="chat-header_title">
      <div class="chat-title">{{configAi.title}}</div>
      <div class="chat-title-sub">{{configAi.subTitle}}<strong class="strong">AI Agent</strong></div>
    </div>
    <div class="chat-header_tool">
      <div class="tool-delete" @click="onClear">
        <img class="tool-img" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/chat_clear.png">
      </div>
      <div v-if="showClear" class="tool-close" @click="onClose">
        <img class="tool-img" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/chat_close.png">
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      showClear: {
        type: Boolean,
        default: false
      }
    },
    data() {
      const time = Date.now()
      return {
        titleUrl: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/ai/v2/title_bg.png?_t=" + time
      }
    },
    computed: {
      ...mapGetters(['configAi'])
    },
    methods: {
      onClear() {
        this.$emit('clear')
      },
      onClose() {
        this.$router.back()
      }
    }
  }

</script>

<style lang="scss" scoped>
  .izt-chat-header {
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .chat-header_image {
    width: 190px;
    font-size: 0;
  }
  .chat-header_title {
    flex: 1;
    width: 200px;
    padding-right: 30px;
    .chat-title {
      font-size: 26px;
      font-weight: bold;
      color: #525459;
    }
    .chat-title-sub {
      font-size: 12px;
      color: #525459;
      .strong {
        color: #000000;
        margin-left: 5px;
      }
    }
  }
  .image-wrap {
    position: relative;
  }
  .title-bot-img {
    position: absolute;
    right: -31px;
    top: -4px;
  }
  .chat-header_tool {
    display: flex;
    align-items: center;
  }
  .tool-delete {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
  }
  .tool-close {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
    margin-left: 14px;
  }
  .tool-img {
    width: 100%;
    height: 100%;
  }
</style>